import { Directive, Input, HostBinding } from '@angular/core';
import { NavPanel } from './nav-panel.interface';
import { BaseDirective } from '../../base/_base.directive';


@Directive({
  selector: 'nav-panel, [navPanel]'
})
export class NavPanelDirective extends BaseDirective implements  NavPanel {
  @HostBinding('class.nav') nav: boolean = true;

  @HostBinding('class.nav-pills')
  @Input() pills: boolean = true;

  @HostBinding('class.nav-tabs')
  @Input() tabs: boolean = false;
  // justified or fill
  @Input()
  set widthAlign(align: string) {
    this.setClassName(`nav-${align}`);
  }

}
